import BlobImage from "../../../components/BlobImage/BlobImage";
import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import "./Index.css";

export default function NewsBlogs({ newsBlogs }) {
  const { translations } = useSelector((state) => state.language);
  const t = useMemo(() => translations?.labels || {}, [translations]);
  const hasNews = newsBlogs && newsBlogs.length > 0;

  const formatDate = (dateString) => {
    if (!dateString) return "";
    return new Date(dateString)
      .toLocaleDateString("en-GB", {
        month: "short",
        day: "2-digit",
        year: "numeric",
      })
      .replace(/ /g, "-");
  };

  return (
    <div className="blogs-section">
      <h2 className="blogs-heading">{t.newsAndBlogs || "News and Blogs"}</h2>

      {hasNews ? (
        <div className="blogs-grid">
          {newsBlogs.map((blog) => (
            <div key={blog.id} className="blog-card">
              {/* Image */}
              <div className="blog-image">
                {blog.image ? (
                  <BlobImage path={blog.image} alt={blog.subject} />
                ) : (
                  <div className="blog-image-placeholder">
                    <span>Card image cap</span>
                  </div>
                )}
              </div>

              {/* Content */}
              <div className="blog-content">
                <a
                  href={blog.link || "#"}
                  className="blog-title"
                  target="_blank"
                  rel="noreferrer"
                >
                  {blog.subject}
                </a>

                <div className="blog-date">{formatDate(blog.date)}</div>

                {blog.link && (
                  <div className="blog-source">
                    {t.source || "Source"}:{" "}
                    <a href={blog.link} target="_blank" rel="noreferrer">
                      {blog.link.length > 30
                        ? `${blog.link.substring(0, 30)}...`
                        : blog.link}
                    </a>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="blogs-empty">
          <div className="bird-wrapper">
            <svg
              width="80"
              height="90"
              viewBox="0 0 80 90"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <ellipse cx="40" cy="45" rx="28" ry="30" fill="#6B4EAD" />
              <ellipse cx="40" cy="12" rx="8" ry="12" fill="#6B4EAD" />
              <circle cx="40" cy="8" r="5" fill="#8B6EC9" />
              <ellipse cx="32" cy="38" rx="6" ry="7" fill="white" />
              <ellipse cx="48" cy="38" rx="6" ry="7" fill="white" />
              <circle cx="33" cy="39" r="3" fill="#333" />
              <circle cx="49" cy="39" r="3" fill="#333" />
              <circle cx="34" cy="38" r="1" fill="white" />
              <circle cx="50" cy="38" r="1" fill="white" />
              <ellipse cx="40" cy="52" rx="5" ry="4" fill="#FFB74D" />
              <ellipse cx="18" cy="50" rx="10" ry="15" fill="#8B6EC9" />
              <ellipse cx="62" cy="50" rx="10" ry="15" fill="#8B6EC9" />
              <path
                d="M32 75 L28 85 M32 75 L32 85 M32 75 L36 85"
                stroke="#FF8C00"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M48 75 L44 85 M48 75 L48 85 M48 75 L52 85"
                stroke="#FF8C00"
                strokeWidth="3"
                strokeLinecap="round"
              />
            </svg>
          </div>
          <p className="blogs-empty-text"></p>
        </div>
      )}
    </div>
  );
}
